import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function AdminLogin() {
    const { user, login, ready } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    if (ready && user) return <Navigate to="/admin" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            await login(email, password);
        } catch (err) {
            setError(
                err?.response?.data?.detail || "Identifiants invalides"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen bg-xv-midnightDeep flex items-center justify-center px-6"
        >
            <div className="w-full max-w-md">
                <Link
                    to="/"
                    data-testid="admin-back-home"
                    className="inline-flex items-center gap-2 mb-8 text-[10px] tracking-[0.32em] uppercase text-xv-ivory/50 hover:text-xv-gold transition"
                >
                    <ArrowLeft strokeWidth={1.2} size={14} />
                    Retour à l'accueil
                </Link>
                <Link to="/" className="flex justify-center mb-12" data-testid="admin-logo-link">
                    <img
                        src="/brand/logo-principal.png"
                        alt="XV Capital Partners"
                        className="h-24 w-auto"
                    />
                </Link>
                <div className="bg-xv-ivory/[0.04] backdrop-blur-md border border-xv-ivory/15 p-10">
                    <div className="overline text-xv-goldSoft mb-6">
                        Espace administrateur
                    </div>
                    <h1
                        className="font-serif text-xv-ivory text-4xl md:text-5xl mb-10 leading-[1.05]"
                        style={{ fontWeight: 300 }}
                    >
                        Identification
                    </h1>
                    <form onSubmit={onSubmit} className="space-y-8" data-testid="admin-login-form">
                        <div>
                            <label className="overline text-xv-goldSoft block mb-3">
                                Email
                            </label>
                            <input
                                required
                                type="email"
                                data-testid="admin-email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-transparent border-b border-xv-ivory/30 text-xv-ivory py-3 font-light placeholder:text-xv-ivory/30 focus:border-xv-gold focus:outline-none transition"
                                placeholder="admin@xv-capitalpartners.com"
                            />
                        </div>
                        <div>
                            <label className="overline text-xv-goldSoft block mb-3">
                                Mot de passe
                            </label>
                            <input
                                required
                                type="password"
                                data-testid="admin-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-transparent border-b border-xv-ivory/30 text-xv-ivory py-3 font-light focus:border-xv-gold focus:outline-none transition"
                                placeholder="••••••••"
                            />
                        </div>
                        {error && (
                            <p
                                data-testid="admin-login-error"
                                className="text-sm text-red-300/90 font-light"
                            >
                                {error}
                            </p>
                        )}
                        <button
                            type="submit"
                            data-testid="admin-login-submit"
                            disabled={loading}
                            className="w-full mt-4 inline-flex items-center justify-center gap-3 px-8 py-4 bg-xv-gold text-xv-midnightDeep text-[11px] tracking-[0.3em] uppercase hover:bg-xv-goldSoft transition disabled:opacity-60"
                        >
                            {loading ? "Connexion…" : "Se connecter"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
